import { type ActionItem, Divider, toastStore } from 'shared/ui'
import { SwitchAction } from 'shared/ui/SwitchAction'
import { logger } from 'shared/lib'
import {
  type ICallingListResponse,
  type IResponseFullAICallingAgent,
} from 'entities/AICalling/api/types'
import { AiCallingApi } from 'entities/AICalling/api/aiCallingApi'
import { showAIAgentDisabledToast } from 'entities/AIAgent/actions/showAIAgentDisabledToast'
import { disableAgent } from 'pages/chatbot/pages/calling/actions/disableAgent/disableAgent'
import { showSuccessActivatedModal } from 'pages/chatbot/pages/calling/actions/showSuccessActivatedModal/showSuccessActivatedModal'

export const toggleActive = (
  item: ICallingListResponse,
  onSuccessUpdate: (response: IResponseFullAICallingAgent) => void
): ActionItem => {
  const updateStatus = async (status: ICallingListResponse['status']) => {
    const { data } = await AiCallingApi.updateStatus(item.id, status)
    onSuccessUpdate(data)
  }

  const handleError = (e: unknown) => {
    logger.error(e)
    toastStore.add({
      type: 'error',
      title: 'Something went wrong, try again!',
    })
  }

  const handleToggle = async (onCloseMenu?: () => void) => {
    try {
      if (item.status === 'active') {
        await disableAgent({
          id: item.id,
          disableRequest: async () => {
            try {
              await updateStatus('disabled')
              showAIAgentDisabledToast()
            } catch (e) {
              handleError(e)
            }
          },
        })
      } else {
        await updateStatus('active')
        showSuccessActivatedModal()
      }
    } catch (e) {
      handleError(e)
    } finally {
      onCloseMenu?.()
    }
  }
  return {
    dropdownItemComponent: (onCloseMenu) => (
      <>
        <SwitchAction
          size={'xSmall'}
          active={item.status === 'active'}
          onTrigger={() => handleToggle(onCloseMenu)}
          label={item.status === 'active' ? 'Active' : 'Disabled'}
        />
        <Divider sx={{ marginX: -0.5, marginY: 0.5 }} />
      </>
    ),
    withDivider: true,
    buttonComponent: (
      <SwitchAction
        active={item.status === 'active'}
        onTrigger={() => handleToggle()}
        size={'middle'}
      />
    ),
  }
}
